<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.pi_inoutno}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" v-if="form.main.pi_custname" slot="pi_custname">
            <label class="weui-form-preview__label">{{customLabel.pi_custname || "客户"}}</label>
            <span class="weui-form-preview__value">{{form.main.pi_custname}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pi_vendname" slot="pi_vendname">
            <label class="weui-form-preview__label">{{customLabel.pi_vendname || "供应商"}}</label>
            <span class="weui-form-preview__value">{{form.main.pi_vendname}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pi_departmentname" slot="pi_departmentname">
            <label class="weui-form-preview__label">{{customLabel.pi_departmentname || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.pi_departmentname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pi_date">
            <label class="weui-form-preview__label">{{customLabel.pi_date || "入库日期"}}</label>
            <span class="weui-form-preview__value">{{form.main.pi_date}}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pi_text1 || '自定义字段1'"
          v-model="form.main.pi_text1" slot="pi_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text2 || '自定义字段2'"
          v-model="form.main.pi_text2" slot="pi_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text3 || '自定义字段3'"
          v-model="form.main.pi_text3" slot="pi_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text4 || '自定义字段4'"
          v-model="form.main.pi_text4" slot="pi_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pi_text5 || '自定义字段5'"
          v-model="form.main.pi_text5" slot="pi_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.pd_pdno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">{{item.productDTO.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_whname">
            <label class="weui-form-preview__label">{{customLabel.pd_whname || "仓库"}}</label>
            <span class="weui-form-preview__value">{{item.pd_whname}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_inqty">
            <label class="weui-form-preview__label">{{customLabel.pd_inqty || "数量"}}</label>
            <span class="weui-form-preview__value">{{item.pd_inqty}} {{item.productDTO.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_qty_extra" :hidden="!item.productDTO.pr_unit_extra">
            <label class="weui-form-preview__label">{{customLabel.pd_qty_extra || "辅助数量"}}</label>
            <span class="weui-form-preview__value">{{item.pd_qty_extra}} {{item.productDTO.pr_unit_extra}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_price">
            <label class="weui-form-preview__label">{{customLabel.pd_price || "成本单价(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pd_price,'#,##0.####')}}</span>
          </div>
          <div class="weui-form-preview__item"  slot="pd_total">
            <label class="weui-form-preview__label">{{customLabel.pd_total || "金额(元)"}}</label>
            <span class="weui-form-preview__value">{{numberFormat(item.pd_total,'#,##0.00')}}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_sellername">
            <label class="weui-form-preview__label">{{customLabel.pd_sellername || "业务员"}}</label>
            <span class="weui-form-preview__value">{{item.pd_sellername}}</span>
          </div>
          <div class="weui-form-preview__item weui-cell" slot="pd_text1" hidden="true" v-if="item.pd_text1">
              <label class="weui-form-preview__label">{{
                customLabel.pd_text1 || "自定义字段1"
              }}</label>
              <span class="weui-form-preview__value">{{ item.pd_text1 }} </span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1" slot="pd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2" slot="pd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3" slot="pd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4" slot="pd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5" slot="pd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{form.main.pi_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{form.main.pi_costtotal}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/stock/othin_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/storage/prodinout",
      codeField: "pi_inoutno",
      statusField: "pi_statuscode",
      caller: "OtherIn",
      xtype: "stock-otherin-formpanel",
    };
  }
};
</script>